// Menu link appending
$(window).ready(linkIndex);
document.addEventListener("shopify:section:load", linkIndex);

function linkIndex(){
  var nav_link_child = $("#link-navbar-append-holder > .ic-nav-link");
  var block_link_child = $("#block-navbar-append-holder > .ic-block-link");

  nav_link_child.each(function () {
    $(this).attr("data-index", $(this).index());
  });

  block_link_child.each(function () {
    $(this).attr("data-index", $(this).index());
  });
}


$(window).ready(link_append);
$(window).resize(link_append);
document.addEventListener("shopify:section:load", link_append);

function link_append() {
  var link_navbar = $("#link-navbar-append-holder").hasClass("ic-append-md");
  var top_navbar = $("#top-navbar-append-holder").hasClass("ic-append-md");
  var block_navbar = $("#block-navbar-append-holder").hasClass("ic-append-md");
  var nav_link = $("#link-navbar-append-holder > .ic-nav-link:not(.ic-ex-link-md)");
  var top_link = $("#top-navbar-append-holder > .ic-top-link:not(.ic-ex-link-md)");
  var block_link = $("#block-navbar-append-holder > .ic-block-link:not(.ic-ex-link-md)");
  if (window.matchMedia('(max-width: 1023px)').matches && link_navbar == true) {
    nav_link.appendTo("#link-sidebar-append-holder");
  }
  else {
    $("#link-sidebar-append-holder > .ic-nav-link").appendTo("#link-navbar-append-holder");

    var $link_wrapper = $('#link-navbar-append-holder');

    $link_wrapper.children('.ic-nav-link').sort(function (a, b) {
      return +a.dataset.index - +b.dataset.index;
    })
      .appendTo($link_wrapper);
  }

  if (window.matchMedia('(max-width: 1023px)').matches && top_navbar == true) {
    top_link.appendTo("#top-sidebar-append-holder");

    var $top_side_wrapper = $('#top-sidebar-append-holder');

    $top_side_wrapper.children('.ic-top-link').sort(function (a, b) {
      return +b.dataset.index - +a.dataset.index;
    })
      .appendTo($top_side_wrapper);
  }
  else {
    $("#top-sidebar-append-holder > .ic-top-link").appendTo("#top-navbar-append-holder");

    var $top_wrapper = $('#top-navbar-append-holder');

    $top_wrapper.children('.ic-top-link').sort(function (a, b) {
      return +a.dataset.index - +b.dataset.index;
    })
      .appendTo($top_wrapper);
  }

  if (window.matchMedia('(max-width: 1023px)').matches && block_navbar == true) {
    block_link.appendTo("#block-sidebar-append-holder");
  }
  else {
    $("#block-sidebar-append-holder > .ic-block-link").appendTo("#block-navbar-append-holder");

    var $block_wrapper = $('#block-navbar-append-holder');

    $block_wrapper.children('.ic-block-link').sort(function (a, b) {
      return +a.dataset.index - +b.dataset.index;
    })
      .appendTo($block_wrapper);
  }

  if (window.matchMedia('(max-width: 1023px)').matches) {

    $('.ic-block-link').removeAttr('x-link');
    $('.account-link').removeAttr('x-account');
    $('.login-link').removeAttr('x-login');
  }
}

// Dropdown
$(function () {
  $('.ic-dropdown-toggle').click(function () {
    $(this).next('.ic-dropdown-menu').slideToggle();
  });
  $(document).click(function (e) {
    var target = e.target;
    if (!$(target).is('.ic-dropdown-toggle') && !$(target).parents().is('.ic-dropdown-toggle')) { $('.ic-dropdown-menu').slideUp(); }
  });
});

// Menu toggle 
window.addEventListener("DOMContentLoaded", menuToggle);
document.addEventListener("shopify:section:load", menuToggle);
function menuToggle() {
  $('body').removeClass("menu-overlay");
  $('.ic-breadcrumb').click(function (event) {
    event.stopPropagation();
    $('.ic-mobile-sidebar').toggle();
    $('.ic-breadcrumb').attr('aria-expanded', "true");
    $('.ic-mobile-sidebar-header .ic-close-icon').attr('aria-expanded', "true");
    $('.menu-close-overlay').attr('aria-expanded', "true");
    $('body').addClass("menu-overlay");

  });
  $('.ic-mobile-sidebar-header .ic-close-icon').click(function (event) {
    event.stopPropagation();
    $('.ic-mobile-sidebar').toggle();
    $('.ic-breadcrumb').attr('aria-expanded', "false");
    $('.ic-mobile-sidebar-header .ic-close-icon').attr('aria-expanded', "false");
    $('.menu-close-overlay').attr('aria-expanded', "false");
    $('body').removeClass("menu-overlay");
  });
  $('.menu-close-overlay').click(function (event) {
    event.stopPropagation();
    $('.ic-mobile-sidebar').toggle();
    $('.ic-breadcrumb').attr('aria-expanded', "false");
    $('.ic-mobile-sidebar-header .ic-close-icon').attr('aria-expanded', "false");
    $('.menu-close-overlay').attr('aria-expanded', "false");
    $('body').removeClass("menu-overlay");
  });
  const scrollY = $('body').css("top");

};

// Preventing footer to move up from bottom of screen

$(window).on("DOMContentLoaded resize", handleStickyHeader);
$(window).on("DOMContentLoaded resize", main_height);
// $(document).ready(main_height);

function main_height() {
  var header_group_height = $('.header-group').length ? $('.header-group').height() : 0;
  var footer_group_height = $('.footer-group').length ? $('.footer-group').height() : 0;
  var breadcrumb_height_val = $('#breadcrumbs').length ? $('#breadcrumbs').height() : 0;
  var inner_header_height = $('.ic-header').length ? $('.ic-header').outerHeight() : 0;
  var header_height = $('.transparent-header').length ? $('.transparent-header').outerHeight() : 0;
  var header_top_bar_height = $('.transparent-header .header-top-bar').length ? $('.transparent-header .header-top-bar').outerHeight() : 0;
  var viewport_height = $(window).height();
  if (breadcrumb_height_val) {
    var breadcrumb_height = breadcrumb_height_val;
  } else {
    var breadcrumb_height = 0;
  }

  var topAnnouncementHeight = 0;
  $('.header-group > *:not(.skip-link)').each(function() {
    if ($(this).is('header')) {
      return false;
    }
    var announcementHeight = $(this).outerHeight();
    topAnnouncementHeight += announcementHeight;
  });
  var bottomAnnouncementHeight = 0;
  var isBtAnnouncement = false;
  $('.header-group > *:not(div):not(.skip-link)').each(function() {
    if(isBtAnnouncement){
      var btannouncementHeight = $(this).outerHeight();
      bottomAnnouncementHeight += btannouncementHeight;
    }
    if ($(this).is('header')) {
      isBtAnnouncement = true;
    }
  });
  $('body').css('--header-group', header_group_height + 'px');
  $('body').css('--header-top', topAnnouncementHeight + 'px');
  $('body').css('--header-top-bar-height', header_top_bar_height + 'px');
  $('body').css('--inner-header-height', inner_header_height + 'px');
  $('body').css('--header-height', header_height + 'px');
  $('body').css('--header-bottom', bottomAnnouncementHeight + 'px');

  var min_height = viewport_height - header_group_height - footer_group_height - breadcrumb_height + 'px'

  $('#MainContent').css('min-height', min_height);
  $('.fill-screen-height').css('--main-height', min_height);
  $('.footer-group').removeAttr('x-footer');
  
  let lastScrollTop = 0;
  let lastScrollDown = 0;
  let lastScrollUp = 0;
  let lastScrollUpAmount = 0;
  let lastScrollUDownAmount = 0;
  let headerScrollTop = 0;

  if($(window).scrollTop() > (topAnnouncementHeight + $('.header-top-bar').outerHeight())){
    headerScrollTop = 0;
  }else{
    headerScrollTop = topAnnouncementHeight;
  }
  $(window).scroll(function() {
    const currentScrollTop = $(window).scrollTop();
    const headerTopHeight = $('.header-top-bar').length ? $('.header-top-bar').outerHeight() : 0;
    const scrollTopLimit = topAnnouncementHeight + headerTopHeight;
    const initialScrollTop = topAnnouncementHeight;
    if (currentScrollTop > lastScrollTop) {
      lastScrollUDownAmount = (currentScrollTop - lastScrollUp);
      if(currentScrollTop <= scrollTopLimit){
        headerScrollTop = initialScrollTop - currentScrollTop;
        if(headerScrollTop <= (headerTopHeight * -1)){
          headerScrollTop = (headerTopHeight * -1);
        }
      }else{
        const currHeaderScroll = ((headerTopHeight - lastScrollUpAmount) * -1) - lastScrollUDownAmount;
        if(headerScrollTop > currHeaderScroll){
          headerScrollTop = currHeaderScroll;
        }else{
          headerScrollTop = 0 - lastScrollUDownAmount;
        }
        if(headerScrollTop <= (headerTopHeight * -1)){
          headerScrollTop = (headerTopHeight * -1);
        }
      }
      lastScrollDown = $(window).scrollTop();
    } else {
      lastScrollUpAmount = (lastScrollDown - currentScrollTop);
      if(currentScrollTop <= scrollTopLimit){
        const currHeaderScroll = ((lastScrollDown - initialScrollTop) * -1) + lastScrollUpAmount;
        if(headerScrollTop < currHeaderScroll){
          headerScrollTop = currHeaderScroll;
        }else{
          const extraHeaderScroll = (headerTopHeight * -1) + (lastScrollDown - (lastScrollDown - lastScrollUpAmount));
          headerScrollTop = extraHeaderScroll;
          if(headerScrollTop >= 0){
            headerScrollTop = 0;
          }
        }
        if(headerScrollTop >= initialScrollTop){
          headerScrollTop = initialScrollTop;
        }
      }else{
        // Issue pending when scrooling down and up from middle of topbar also need to check with transparent header
        const currHeaderScroll = (0 - lastScrollUDownAmount) + lastScrollUpAmount;
        if(currHeaderScroll >= (headerTopHeight * -1)){
          headerScrollTop = currHeaderScroll;
        }else{
          headerScrollTop = (headerTopHeight * -1) + lastScrollUpAmount;
        }

        if(headerScrollTop >= 0){
          headerScrollTop = 0;
        }
        // console.log(headerScrollTop + " -> " + lastScrollUDownAmount + " :: " + lastScrollUpAmount + " == " + currHeaderScroll);
      }
      lastScrollUp = $(window).scrollTop();
    }
    lastScrollTop = currentScrollTop;
    $('body').css('--fixed-header-top', headerScrollTop + 'px');
  })

  
  let footerContactForm = $('#footerContactForm');
  let passwordContactForm = $('#passwordContactForm');
  
  $(document).ready(function() {
      if (window.location.hash === '#footerContactForm') {
          $('html, body').scrollTop(footerContactForm.offset().top);
      }
      if (window.location.hash === '#passwordContactForm') {
          $('html, body').scrollTop(passwordContactForm.offset().top);
      }
      let newsLetterFormArr = document.querySelectorAll('.newsletter-wrapper form');
      newsLetterFormArr.forEach(function(newsLetterForm) {
        let formID = '#' + newsLetterForm.getAttribute('id');
        if (window.location.hash ===  formID) {
          let htmlBody = document.querySelector('html, body');
          let newsLetter = document.querySelector(formID).closest('section');
          let offset = newsLetter.offsetTop - header_group_height;
          htmlBody.scrollTo({
            top: offset
          });
        }
      })
  });

  var scrollHeight = 50 + topAnnouncementHeight;

  $(window).scroll(function() {
    let headerBehavior = $('.fixed-header').data('behavior');
    if(headerBehavior == 'sticky'){
      transparentHeaderScroll();
    }
  }); 
  document.addEventListener('shopify:section:load', function(){
    let headerBehavior = $('.fixed-header').data('behavior');
    if(headerBehavior == 'sticky'){
      transparentHeaderScroll();
    }
  });

  function transparentHeaderScroll() {
    const transparentHeader = $('.transparent-header');
    const slideBgHeader = $('.transparent-header[data-slide-bg]');
    if ($(window).scrollTop() >= scrollHeight) {
      transparentHeader.addClass('scrolled');
      slideBgHeader.children('.content-container').removeClass('text-inherit');
      if (slideBgHeader.find('.bottom-menu-content').length > 0) {
        slideBgHeader.find('.bottom-menu-content').removeClass('text-inherit');
      }
    } else {
      transparentHeader.removeClass('scrolled');
      slideBgHeader.children('.content-container').addClass('text-inherit');
      if (slideBgHeader.find('.bottom-menu-content').length > 0) {
        slideBgHeader.find('.bottom-menu-content').addClass('text-inherit');
      }
    }
  }

}

function handleStickyHeader(){
  let headerBehavior = $('.fixed-header').data('behavior');
  if(headerBehavior == 'normal'){
    $('.section-header').removeClass('fixed-header-section')
  }
}

document.addEventListener('shopify:section:load', function (event) {
  handleStickyHeader();
  main_height();
  sectionAllowTransparent();
  $('footer').removeAttr('x-footer');
});
document.addEventListener('shopify:section:reorder', function (event) {
  handleStickyHeader();
  main_height();
  sectionAllowTransparent();
});

$(window).on("DOMContentLoaded", sectionAllowTransparent);


function sectionAllowTransparent(){
  const defaultHeader = $('.ic-header');
  const transparentHeader = $('.transparent-header');
  const sectionHeader = $('.section-header');
  const headerGroup = $('.header-group');
  if ($('.allow-transparent-header').closest('.shopify-section').is(':first-child')) {
    if(defaultHeader.hasClass('transparent-header')){
      transparentHeader.addClass('section-allow');
      sectionHeader.addClass('transparent-header-section');
      headerGroup.addClass('transparent-header-group');
      $('.allow-transparent-header').closest('.shopify-section:first-child').addClass('section-allow');
    }
  } else {
    transparentHeader.removeClass('section-allow');
    sectionHeader.removeClass('transparent-header-section');
    headerGroup.removeClass('transparent-header-group');
  }
}


// Share button
function shareButton() {
  $('.btn--share').on('click', function () {
    $('.social-sharing-wrapper').toggleClass('opened');
    if ($(this).attr('aria-expanded') == "false") {
      $(this).attr('aria-expanded', "true");
    } else {
      $(this).attr('aria-expanded', "false");
    }
  });
  $(document).mouseup(function (e) {
    if ($(e.target).closest('.social-sharing-wrapper').length === 0) {
      $('.social-sharing-wrapper').removeClass('opened');
      $('.btn--share').attr('aria-expanded', "false");
    }
    if ($(e.target).closest('.selectbox').length === 0) {
      $('.selectbox').removeClass('opened');
      // $('.btn--share').attr('aria-expanded', "false");
    }
  });
}
function LinkCopy() {
  const linkCopyBtnArr =  document.querySelectorAll('.link-copy-button');
  for(let i = 0; i < linkCopyBtnArr.length; i++){
    linkCopyBtnArr[i].addEventListener('click',function(){
      var copyText = linkCopyBtnArr[i].closest('.link-copy').querySelector(".copy-link");
    
      const textToCopy = copyText.innerText;
      const tempInput = document.createElement('input');
      tempInput.value = textToCopy;
      tempInput.style.position = 'absolute';
      tempInput.style.left = '-9999px';
      document.body.appendChild(tempInput);
      tempInput.select();
      document.addEventListener('copy', (event) => {
        event.preventDefault();
        event.clipboardData.setData('text/plain', textToCopy);
      });
      document.execCommand('copy');
      document.body.removeChild(tempInput);
    
      document.querySelector('.copied-message').classList.add('show');
      setTimeout(() => {
        document.querySelector('.copied-message').classList.remove('show');
      }, 2000);
    });
  }
}

window.addEventListener("load", shareButton);
document.addEventListener("shopify:section:load", shareButton);

window.addEventListener("load", LinkCopy);
document.addEventListener("shopify:section:load", LinkCopy);

try {
  var heroSwiper = document.querySelectorAll('.hero-swiper');
  for (var i = 0; i < video_preview_elements.length; i++) {
    slide_show_count = video_preview_elements.length;
  }

} catch (e) { }

class VariantSelector extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }
  onVariantChange() {
    this.addLoader();
    this.getSelectedOptions();
    this.getSelectedVariant();
    this.updateVariant();
    this.updateBuyButton();
    this.updateURL();
    this.updateFormID();
    this.updateProductDetails();
  }
  getSelectedOptions() {
    this.options = Array.from(this.querySelectorAll('input[type="radio"]:checked'), (select) => select.value);
  }
  getVariantJSON() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
  getSelectedVariant() {
    this.currentVariant = this.getVariantJSON().find((variant) => {
      const findings = !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
      if (findings) return variant;
    });
  }
  updateURL() {
    if (!this.currentVariant) return;
    if(this.dataset.urlUpdate == 'true'){
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }
  }
  updateFormID() {
    if (!this.currentVariant) return;
    const form_inputs = this.closest('.product-form-wrapper').querySelectorAll('input[name="id"]');
    for (let i = 0; i < form_inputs.length; i++){
      form_inputs[i].value = this.currentVariant.id;
    }
  }
  updateProductDetails() {
    let fetchURL = '';
    if (this.currentVariant) {
      fetchURL = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;
    } else { fetchURL = ''; }
    fetch(fetchURL)
      .then((response) => {
        if (response.ok) { return response.text(); }
        throw new Error('Something went wrong');
      })
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        
        const oldSectionId = this.closest('.product-detail').getAttribute('id');
        const oldSection = this.closest('.product-detail');
        const newSection = html.querySelector(`#${oldSectionId}`);
        
        const id = `price-${this.dataset.section}`;
        const oldPrice = document.getElementById(id);
        oldPrice.style.opacity = '1';
        const newPrice = html.getElementById(id);
        if (oldPrice && newPrice) oldPrice.innerHTML = newPrice.innerHTML;

        const buttonId = `buy-${this.dataset.section}`;
        const oldButtons = document.getElementById(buttonId);
        const oldQuantityId = `quantity-${this.dataset.section}`;
        const oldQuantityContainer = document.getElementById(oldQuantityId).closest('.quantity-container');
        const oldQuantityPlus = oldQuantityContainer.querySelector('.quantity-btn.plus');
        const oldQuantityMinus = oldQuantityContainer.querySelector('.quantity-btn.minus');
        const oldQuantityInput = document.getElementById(oldQuantityId);
        const newButtons = html.getElementById(buttonId);
        const buy_buttons = oldButtons.querySelectorAll('button');
        if (!this.currentVariant.available) {
          for (let i = 0; i < buy_buttons.length; i++) {
            buy_buttons[i].disabled = true;
            if (buy_buttons[i].getAttribute('name') == 'add') {
              buy_buttons[i].innerHTML = window.variantStrings.soldOut;
            }
          }
          oldQuantityContainer.classList.add('disabled');
          oldQuantityPlus.disabled = true;
          oldQuantityMinus.disabled = true;
          oldQuantityInput.disabled = true;
        } else if (this.currentVariant.available) {
          for (let i = 0; i < buy_buttons.length; i++) {
            buy_buttons[i].disabled = false;
            if (buy_buttons[i].getAttribute('name') == 'add') {
              buy_buttons[i].innerHTML = window.variantStrings.addToCart;
            }
          }
          oldQuantityContainer.classList.remove('disabled');
          oldQuantityPlus.disabled = false;
          oldQuantityMinus.disabled = false;
          oldQuantityInput.disabled = false;
        }

        const oldRadioElement = this.querySelectorAll('input[type="radio"]');
        const newRadioElement = html.querySelector('variant-selector').querySelectorAll('input[type="radio"]');
        for (let i = 0; i < newRadioElement.length; i++) {
          if (newRadioElement[i].closest('.radio-container').classList.contains('unavailable')) {
            oldRadioElement[i].closest('.radio-container').classList.add('unavailable');
          } else {
            oldRadioElement[i].closest('.radio-container').classList.remove('unavailable');
          }
        }
        
        
        const oldSku = oldSection.querySelector('.variant-sku');
        const skuWrapper = oldSection.querySelector('.sku-wrapper');
        const newSku = newSection.querySelector('.variant-sku');
        if (oldSku && newSku) {
          oldSku.innerHTML = newSku.innerHTML;
        } else if (!oldSku && newSku) {
          skuWrapper.append(newSku);
        } else if (!newSku && oldSku) {
          oldSku.remove();
        }

        const mediaId = `media-${this.dataset.section}`;
        const oldMedia = document.getElementById(mediaId);
        const oldMediaClassList = oldMedia.classList.contains('em-vdapp--initiated');
        if (!oldMediaClassList) {
          const newMedia = html.getElementById(mediaId);
          if (oldMedia && newMedia) oldMedia.innerHTML = newMedia.innerHTML;
          productSectionSlider();
          thumbProductModel();
          shopifyXr();
          cleanUpVideoPlayers();
          videoPlayerInitialise(`#${mediaId}`);
        }

        const shareId = `.product_feature`;
        const oldShare = oldSection.querySelector(shareId);
        const newShare = newSection.querySelector(shareId);
        if (oldShare && newShare) oldShare.innerHTML = newShare.innerHTML;
        shareButton();
        LinkCopy();

        const inventoryId = `inventory-${this.dataset.section}`;
        const inventoryWrapper = document.getElementById(`inventory-wrapper-${this.dataset.section}`);
        const oldInventory = document.getElementById(inventoryId);
        if (oldInventory) {
          oldInventory.style.visibility = 'visible';
        }
        const newInventory = html.getElementById(inventoryId);
        if (oldInventory && newInventory) {
          oldInventory.innerHTML = newInventory.innerHTML;
        } else if (!oldInventory && newInventory) {
          inventoryWrapper.append(newInventory);
        } else if (!newInventory && oldInventory) {
          oldInventory.remove();
        }

        const oldVariantCartCountEl = oldSection.querySelector('[data-cart-count]');
        const newVariantCartCountEl = newSection.querySelector('[data-cart-count]');
        const newVariantCartCount = newVariantCartCountEl.getAttribute('data-cart-count');
        oldVariantCartCountEl.setAttribute('data-cart-count', newVariantCartCount);

        const quantityId = `quantity-${this.dataset.section}`;
        const oldQuantity = document.getElementById(quantityId);
        const oldFormInput = oldSection.querySelector('input[name="quantity"][type="hidden"]');
        const oldMaxQuantity = oldQuantity.getAttribute('max');
        const newQuantity_el = html.getElementById(quantityId);
        const newQuantity = newQuantity_el.hasAttribute('max');
        if (newQuantity) {
          oldQuantity.setAttribute('max', newQuantity_el.getAttribute('max'));
        }
        if (!newQuantity) {
          oldQuantity.removeAttribute('max');
        }
        if (newQuantity && oldQuantity.value * 1 > newQuantity_el.getAttribute('max') * 1) {
          oldQuantity.value = newQuantity_el.getAttribute('max');
          oldFormInput.value = newQuantity_el.getAttribute('max');
        }
        hidequantityError(oldSection);
        hideAddToCartError(oldSection);

        const oldVariantAvailabilityEl = oldSection.querySelector('[data-availibility]');
        const newVariantAvailabilityEl = newSection.querySelector('[data-availibility]');
        const newVariantAvailability = newVariantAvailabilityEl.getAttribute('data-availibility');
        oldVariantAvailabilityEl.setAttribute('data-availibility', newVariantAvailability);

        const pickupId = `pickup-${this.dataset.section}`;
        const wrapperId = `pickup-wrapper-${this.dataset.section}`;
        const pickupWrapper = document.getElementById(wrapperId);
        const oldPickup = document.getElementById(pickupId);
        if (oldPickup) {
          pickupWrapper.style.display = 'block';
        }
        const newPickup = html.getElementById(pickupId);
        if (oldPickup && newPickup) {
          oldPickup.innerHTML = newPickup.innerHTML;
        } else if (!oldPickup && newPickup) {
          pickupWrapper.append(newPickup);
        } else if (!newPickup && oldPickup) {
          oldPickup.remove();
        }

        const pickupLocationId = `pickup-location-${this.dataset.section}`;
        const locationWrapperId = `pickup-location-wrapper-${this.dataset.section}`;
        const pickupLocationWrapper = document.getElementById(locationWrapperId);
        const oldPickupLocation = document.getElementById(pickupLocationId);
        const newPickupLocation = html.getElementById(pickupLocationId);
        if (oldPickupLocation && newPickupLocation) {
          oldPickupLocation.innerHTML = newPickupLocation.innerHTML;
        } else if (!oldPickupLocation && newPickupLocation) {
          pickupLocationWrapper.append(newPickupLocation);
        } else if (!newPickupLocation && oldPickupLocation) {
          oldPickupLocation.remove();
        }

        this.removeLoader();
      })
      .catch((error) => {
        console.log(error);
        const id = `price-${this.dataset.section}`;
        const oldPrice = document.getElementById(id);
        oldPrice.style.opacity = '0.5';
        const inventoryId = `inventory-${this.dataset.section}`;
        const oldInventory = document.getElementById(inventoryId);
        if (oldInventory) {
          oldInventory.style.visibility = 'hidden';
        }
        const pickupId = `pickup-${this.dataset.section}`;
        const wrapperId = `pickup-wrapper-${this.dataset.section}`;
        const pickupWrapper = document.getElementById(wrapperId);
        const oldPickup = document.getElementById(pickupId);
        if (oldPickup) {
          pickupWrapper.style.display = 'none';
        }
        this.removeLoader();
      });
  }
  updateVariant() {
    const radio_element = this.querySelectorAll('input[type="radio"]');
    for (let i = 0; i < radio_element.length; i++) {
      if (radio_element[i].checked) {
        radio_element[i].setAttribute('checked', 'checked');
        radio_element[i].closest('.radio-container').classList.add('active');
        radio_element[i].closest('.option-group').querySelector('.option-label span').innerHTML = radio_element[i].value
      } else {
        radio_element[i].removeAttribute('checked');
        radio_element[i].closest('.radio-container').classList.remove('active');
      }
      let currentVariantTitle = '';
      this.options.map((option, index) => {
        if(index != 0){
          currentVariantTitle += ' / '
        }
        const optionPosition = radio_element[i].closest('.option-group').dataset.option;
        if(optionPosition == (index + 1)){
          currentVariantTitle += radio_element[i].value
        }else{
          currentVariantTitle += option
        }
      })
      for (let j = 0; j < this.variantData.length; j++) {
        let variant = this.variantData[j];
        if (variant.title == currentVariantTitle) {
          radio_element[i].closest('.radio-container').classList.remove('unavailable');
          if(variant.available) {
            radio_element[i].closest('.radio-container').classList.remove('sold-out');
          }else{
            radio_element[i].closest('.radio-container').classList.add('sold-out');
          }
          break;
        } else {
          radio_element[i].closest('.radio-container').classList.add('unavailable');
        }
      }
    }
    
  }
  updateBuyButton() {
    const updatedButtonId = `buy-${this.dataset.section}`;
    const updateOldButtons = document.getElementById(updatedButtonId);
    const oldQuantityId = `quantity-${this.dataset.section}`;
    const oldQuantityContainer = document.getElementById(oldQuantityId).closest('.quantity-container');
    const oldQuantityPlus = oldQuantityContainer.querySelector('.quantity-btn.plus');
    const oldQuantityMinus = oldQuantityContainer.querySelector('.quantity-btn.minus');
    const oldQuantityInput = document.getElementById(oldQuantityId);
    const updateUnavailableButton = updateOldButtons.querySelectorAll('button');
    const activeOptions = this.querySelectorAll('input[type="radio"][checked]');
    let variantNotAvailable = false;
    for (let i = 0; i < activeOptions.length; i++) {
      if (activeOptions[i].closest('.radio-container').classList.contains('unavailable')) {
        variantNotAvailable = true;
      }
    }
    if (variantNotAvailable) {
      const updateBuyButtons = updateOldButtons.querySelectorAll('button');
      for (let i = 0; i < updateBuyButtons.length; i++) {
        updateBuyButtons[i].disabled = true;
        if (updateBuyButtons[i].getAttribute('name') == 'add') {
          updateBuyButtons[i].innerHTML = window.variantStrings.unavailable;
        }
      }
      oldQuantityContainer.classList.add('disabled');
      oldQuantityPlus.disabled = true;
      oldQuantityMinus.disabled = true;
      oldQuantityInput.disabled = true;
    }
  }
  addLoader() {
    let loaderWrappers = this.closest('.product-detail').querySelectorAll('.load-wrapper');
    for (let i = 0; i < loaderWrappers.length; i++) {
      loaderWrappers[i].setAttribute('data-loading', 'loading');
    }
  }
  removeLoader() {
    let loaderWrappers = this.closest('.product-detail').querySelectorAll('.load-wrapper');
    for (let i = 0; i < loaderWrappers.length; i++) {
      loaderWrappers[i].removeAttribute('data-loading');
    }
  }
}
customElements.define('variant-selector', VariantSelector);



window.addEventListener('DOMContentLoaded', function(){
  cloneScrollingText();
});
window.addEventListener('resize', function(){
  cloneScrollingText();
});
document.addEventListener('shopify:section:load', function(){
  cloneScrollingText();
});
function cloneScrollingText(){
  const scrollingSections = document.querySelectorAll('.scrollign-text-section');
  for (let i = 0; i < scrollingSections.length; i++) {
      const scrollingSection = scrollingSections[i];
      const scrollingWrapper = scrollingSections[i].querySelector('.scrolling-wrapper');
      scrollingWrapper.classList.add('no-scrolling');
      const scrollingText = scrollingSections[i].querySelector('.scrolling-text-wrapper');
      if(scrollingText){
        calculateAnimationDuration(scrollingWrapper, scrollingText);
        duplicateText(scrollingWrapper, scrollingText);
      }else{
        scrollingWrapper.classList.remove('no-scrolling');
      }
  }
}
function duplicateText(scrollingWrapper, scrollingText){
  const screenWidth = window.innerWidth;
  const scrollingTextWidth = scrollingText.offsetWidth;
    const duplicatesNeeded = Math.ceil(screenWidth / scrollingTextWidth);
    for (let i = 0; i < duplicatesNeeded; i++) {
      const duplicatedText = scrollingText.cloneNode(true);
      if (i == 0) {
            scrollingWrapper.replaceChildren(duplicatedText);
            continue;
      }
      duplicatedText.setAttribute('aria-hidden', true);
      scrollingWrapper.appendChild(duplicatedText);
  }
  const additionalDuplicatedText = scrollingText.cloneNode(true);
  additionalDuplicatedText.setAttribute('aria-hidden', true);
  scrollingWrapper.appendChild(additionalDuplicatedText);
  scrollingWrapper.classList.remove('no-scrolling');
}

function calculateAnimationDuration(scrollingWrapper, scrollingText) {
  const wrapperWidth = scrollingWrapper.offsetWidth;
  const animationSpeed = scrollingWrapper.getAttribute('animation-duration');
  const textWidth = scrollingText.offsetWidth;
    let animationDuration = textWidth / wrapperWidth;

  if (window.innerWidth >= 1280) {
    animationDuration *= (animationSpeed * 2);
  }else if (window.innerWidth >= 1024 && window.innerWidth <= 1279) {
    animationDuration *= (animationSpeed * 1.5);
  }else if (window.innerWidth >= 768 && window.innerWidth <= 1023) {
    animationDuration *= (animationSpeed * 1);
  }else if (window.innerWidth <= 767) {
    animationDuration *= (animationSpeed * 0.5);
  }

  scrollingWrapper.style.setProperty('--animation-duration', `${animationDuration}s`);
}

    document.addEventListener('DOMContentLoaded', productSectionSlider);
    document.addEventListener('shopify:section:load', productSectionSlider);
    function productSectionSlider(){
      const productSectionSliders = document.querySelectorAll('.product-medias');
      productSectionSliders.forEach(productSectionSlider => {
        const section = '#' + productSectionSlider.id;
        productSlider(section);
      });
    }
    function productSlider(section) {
      let thumbSwiper = section + ' .thumb-swiper';
      let mainSwiper = section + ' .main-swiper';
      let swiperPrev = document.querySelector(`${mainSwiper} ~ button.main-swiper-prev`);
      let swiperNext = document.querySelector(`${mainSwiper} ~ button.main-swiper-next`);

      try {
        var swiper = new Swiper(thumbSwiper, {
          direction: 'horizontal',
          loop: false,
          spaceBetween: 20,
          slidesPerView: 3,
          allowTouchMove: true,
          autoHeight: true,
          navigation: false,
          breakpoints: {
            568: {
              slidesPerView: 4,
            },
            768: {
              slidesPerView: 4,
            },
            1024: {
              slidesPerView: 5,
            },
          },
          on: {
            init: function () {
              $(thumbSwiper).removeAttr('x-swiper');
            },
          },
          a11y: {
            slideLabelMessage: `${ window.slideLabels.goTo } {{index}}`,
            itemRoleDescriptionMessage: `${ window.slideLabels.slide }`
          },
        });
        var swiper_main = new Swiper(mainSwiper, {
          loop: false,
          spaceBetween: 58,
          allowTouchMove: false,
          autoHeight: true,
          thumbs: {
            swiper: swiper,
          },
          navigation: {
            nextEl: '.main-swiper-next',
            prevEl: '.main-swiper-prev',
          },
          breakpoints: {
            1281: {
              allowTouchMove: true,
            },
          },
          on: {
            init: function () {
              $(mainSwiper).removeAttr('x-swiper');
              if (window.innerWidth <= 767) {
                if(this.slides.length > 1){
                  swiperPrev.classList.remove('show');
                  swiperNext.classList.add('show');
                }else{
                  swiperPrev.classList.remove('show');
                  swiperNext.classList.remove('show');
                }
                swiperPrev.addEventListener('click', () => {
                  swiper_main.slidePrev();
                });
                swiperNext.addEventListener('click', () => {
                  swiper_main.slideNext();
                });
              }
            },
            reachEnd: function () {
              if (window.innerWidth <= 767) {
                swiperPrev.classList.add('show');
                swiperNext.classList.remove('show');
              }
            },
            reachBeginning: function () {
              if (window.innerWidth <= 767) {
                swiperPrev.classList.remove('show');
                swiperNext.classList.add('show');
              }
            },
            slideChange: function () {
              if (window.innerWidth <= 767) {
                if (!swiper_main.isEnd) {
                  swiperNext.classList.add('show');
                }else{
                  swiperNext.classList.remove('show');
                }
                if (!swiper_main.isBeginning) {
                  swiperPrev.classList.add('show');
                }else{
                  swiperPrev.classList.remove('show');
                }
              }
            },
            slideChangeTransitionEnd: () => activeProductModel(swiper_main),
          },
          a11y: {
            slideLabelMessage: `${ window.slideLabels.item } {{index}}`,
            itemRoleDescriptionMessage: `${ window.slideLabels.slide }`
          },
        });
        function swiperNavDisplay() {
          if (window.innerWidth <= 767) {
              if (!swiper_main.isEnd) {
                swiperNext.classList.add('show');
              }else{
                swiperNext.classList.remove('show');
              }
              if (!swiper_main.isBeginning) {
                swiperPrev.classList.add('show');
              }else{
                swiperPrev.classList.remove('show');
              }
          } else {
            swiperNext?.classList.remove('show');
            swiperPrev?.classList.remove('show');
          }
        }
        window.addEventListener('resize', swiperNavDisplay);

        var thumbSlides = document.querySelectorAll(thumbSwiper + ' .swiper-slide');
        for (let i = 0; i < thumbSlides.length; i++) {
          thumbSlides[i].addEventListener('keydown', function (event) {
            if (event.key === 'Enter') {
              if (this === document.activeElement) {
                var slideIndex = Array.prototype.indexOf.call(this.parentNode.children, this);
                swiper.slideTo(slideIndex);
                swiper_main.slideTo(slideIndex);
              }
            }
          });
        }
      } catch (e) {
        console.log('Swiper JS is not defined', e);
      }
      setImageZoom();
      swiper_main.on('transitionEnd', function () {
        var tarnsitionActiveSlide = document.querySelector(thumbSwiper + ' .swiper-slide-thumb-active');
      });
      function setImageZoom() {
        var ImageZoomElWrapper = document.querySelectorAll(mainSwiper + ' .swiper-slide');
        for (let i = 0; i < ImageZoomElWrapper.length; i++) {
          var imageZoomEl = ImageZoomElWrapper[i].querySelector('.zoom-wrapper');
          if (imageZoomEl) {
            var imageZoomUrl = imageZoomEl.querySelector('img').getAttribute('data-zoom');
            if (typeof $(imageZoomEl).zoom === 'function') {
              $(imageZoomEl).zoom({
                url: imageZoomUrl,
                magnify: 1.25,
                onZoomIn: function () {
                  var mainImage = this.parentNode.querySelector('[data-zoom]');
                  mainImage.style.opacity = '0';
                },
                onZoomOut: function () {
                  var mainImage = this.parentNode.querySelector('[data-zoom]');
                  mainImage.style.opacity = '1';
                },
              });
            } else{
              console.error("Zoom function is not available.");
            }
          }
        }
      }
    }
    function activeProductModel(productSwiper){
      let productSwiperEl = productSwiper.el;
      let firstModelID = productSwiperEl.dataset.firstModel;
      let modelXrButton = productSwiperEl.querySelector('.btn-xr');
      let activeSlide = productSwiperEl.querySelector('.swiper-slide-active');
      let activeModel = activeSlide.querySelector('product-model');
      if(activeModel){
        let modelMediaID = activeModel.dataset.mediaId;
        modelXrButton.setAttribute('data-shopify-model3d-id', modelMediaID)
        }else{
          if(firstModelID != ""){
            modelXrButton.setAttribute('data-shopify-model3d-id', firstModelID)
          }
      }
    }

    document.addEventListener('DOMContentLoaded', sectionSlider);
    document.addEventListener('shopify:section:load', sectionSlider);
    function sectionSlider(){
        const featureSliders = document.querySelectorAll('.featured-collection-slider');
        for (let i = 0; i < featureSliders.length; i++) {
            const featureSlider = featureSliders[i];
            const section = '#' + featureSlider.id;
            collectionSlider(section);
        }
    }
    function collectionSlider(section) {
        try {
            let swiper = new Swiper(section, {
                spaceBetween: 20,
                slidesPerView: 1,
                allowTouchMove: true,
                navigation: {
                  prevEl: '.slider-btn-prev',
                  nextEl: '.slider-btn-next'
                },
                clickable: true,
                breakpoints: {
                  568: {
                    slidesPerView: 2,
                  },
                  768: {
                    slidesPerView: 1,
                  },
                  1024: {
                    slidesPerView: 2,
                  },
                  1280: {
                    slidesPerView: 3,
                  },
                  1536: {
                    slidesPerView: 4,
                  },
                },
                on: {
                  init: function () {
                    $(section).removeAttr('x-swiper');
                  },
                },
            });
        } catch (e) {
            console.log('Swiper JS is not defined');
            console.log(e);
        }
    }


    window.addEventListener('resize', collectionSectionSlider);
    document.addEventListener('DOMContentLoaded', collectionSectionSlider);
    document.addEventListener('shopify:section:load', collectionSectionSlider);
    function collectionSectionSlider(){
        const featureSliders = document.querySelectorAll('.collection-list-slider');
        for (let i = 0; i < featureSliders.length; i++) {
            const featureSlider = featureSliders[i];
            const section = '#' + featureSlider.id;
            const prevBtn = featureSlider.closest('.collection-slider-container').querySelector('.slider-btn-prev');
            const nextBtn = featureSlider.closest('.collection-slider-container').querySelector('.slider-btn-next');
            const dtSlides = featureSlider.dataset.desktopSlides;
            const sdtSlides = featureSlider.dataset.smalldesktopSlides;
            const ltSlides = featureSlider.dataset.laptopSlides;
            const tbSlides = featureSlider.dataset.tabletSlides;
            const mbSlides = featureSlider.dataset.mobileSlides;
            const slideAlignment = featureSlider.dataset.itemAlign;
            const slidesLength = featureSlider.querySelectorAll('.swiper-slide').length;
            const swiperWrapper = featureSlider.querySelector('.swiper-wrapper');
            let screenWidth = window.innerWidth;
            let slidesShown;
            switch(true) {
              case (screenWidth >= 520 && screenWidth < 768):
                slidesShown = mbSlides
                break;
              case (screenWidth >= 768 && screenWidth < 1024):
                slidesShown = tbSlides
                break;
              case (screenWidth >= 1024 && screenWidth < 1280):
                slidesShown = ltSlides
                break;
              case (screenWidth >= 1280 && screenWidth < 1536):
                slidesShown = sdtSlides
                break;
              case (screenWidth >= 1536):
                slidesShown = dtSlides
                break;
              default:
                slidesShown = 1;
            }
            if(slidesLength < slidesShown && slideAlignment == "item-center"){
              swiperWrapper.classList.add('slides-center');
            }else{
              swiperWrapper.classList.remove('slides-center');
            }
            collectionListSlider(section, prevBtn, nextBtn, dtSlides, sdtSlides, ltSlides, tbSlides, mbSlides);
        }
    }
    function collectionListSlider(section, prevBtn, nextBtn, dtSlides, sdtSlides, ltSlides, tbSlides, mbSlides) {
        try {
          let swiper = new Swiper(section, {
                spaceBetween: 20,
                slidesPerView: 1,
                allowTouchMove: true,
                navigation: {
                  prevEl: prevBtn,
                  nextEl: nextBtn
                },
                clickable: true,
                breakpoints: {
                  520: {
                    slidesPerView: mbSlides,
                  },
                  768: {
                    slidesPerView: tbSlides,
                  },
                  1024: {
                    slidesPerView: ltSlides,
                  },
                  1280: {
                    slidesPerView: sdtSlides,
                  },
                  1536: {
                    slidesPerView: dtSlides,
                  },
                },
                on: {
                  init: function () {
                    $(section).removeAttr('x-swiper');
                  },
                }
            });
        } catch (e) {
            console.log('Swiper JS is not defined');
            console.log(e);
        }
    }


    document.addEventListener('DOMContentLoaded', slideshowSectionSlider);
    document.addEventListener('shopify:section:load', slideshowSectionSlider);
    document.addEventListener('shopify:section:reorder', slideshowSectionSlider);
    function slideshowSectionSlider(){
      
        const slideshows = document.querySelectorAll('.hero-swiper');
        for (let i = 0; i < slideshows.length; i++) {
            const slideshow = slideshows[i];
            const autoplayToggle = slideshows[i].querySelector('.autoplay-toggle');
            const section = '#' + slideshow.id;

            let slideshowAutoplay;
            if(slideshow.classList.contains('autoplay')){
              slideshowAutoplay = true;
            }else{
              slideshowAutoplay = false;
            }
            const initSlideshow = slideshow.swiper;
            if(initSlideshow){
              slideShowBg(slideshow)
            }
            if(initSlideshow == undefined){
              slideshowSlider(section, slideshowAutoplay); 
              if(autoplayToggle){
                autoplayToggle.addEventListener('click', function(){
                  const slideshowEl = this.closest('.swiper');
                  const playIcon = this.querySelector('.play-icon');
                  const pauseIcon = this.querySelector('.pause-icon');
                  
                  if(slideshowEl.swiper.autoplay.running){
                    slideshowEl.swiper.autoplay.stop();
                    pauseIcon.classList.add('ic-display-none');
                    playIcon.classList.remove('ic-display-none');
                  }else{
                    slideshowEl.swiper.autoplay.start();
                    playIcon.classList.add('ic-display-none');
                    pauseIcon.classList.remove('ic-display-none');
                  }
                })
              }

              slideShowBg(slideshow)

              slideshow.swiper.on('slideChangeTransitionEnd', function(){
                const activeSlideIndex = slideshow.swiper.activeIndex;
                const activeSlide = slideshow.swiper.slides[activeSlideIndex];
                const activeSlideBg = activeSlide.querySelector('.hero-container').dataset.bg;
                const slideOuterBg = slideshow.closest('.slideshow-wrapper').dataset.outerBg;
                const activeSlideColorScheme = activeSlide.querySelector('.hero-container').dataset.colorScheme;
                slideshow.setAttribute('data-bg-active',activeSlideBg);
                const slideshowClasses = slideshow.classList;
                for (let i = 0; i < slideshowClasses.length; i++) {
                  if (slideshowClasses[i].includes('color-scheme')) {
                      if(slideshowClasses[i] != activeSlideColorScheme){
                        slideshow.classList.remove(slideshowClasses[i]);
                        slideshow.classList.add(activeSlideColorScheme);
                      }
                  }else{
                    slideshow.classList.add(activeSlideColorScheme)
                  }
                }

                const parentContainer = slideshow.parentElement;
                const parentSection = parentContainer.closest('.slideshow-section');
                const transparentHeader = document.querySelector('.transparent-header');
                const transparentHeaderSection = parentContainer.classList.contains('allow-transparent-header');
                const transparentHeaderFullSection = parentContainer.classList.contains('full-width-slideshow');
                
                if(transparentHeader && transparentHeaderSection){
                  if(parentSection.parentElement.firstElementChild === parentSection){
                    if(transparentHeaderFullSection){
                      transparentHeader.setAttribute('data-slide-bg',activeSlideBg);
                    }else{
                      transparentHeader.setAttribute('data-slide-bg',slideOuterBg);
                    }
                  }
                }else{
                  if(transparentHeader && !transparentHeader.classList.contains('section-allow')){
                    transparentHeader.removeAttribute('data-slide-bg');
                  }
                }
              })
            }
        }
        
    }
    function slideshowSlider(section, slideshowAutoplay) {
        try {
          let swiper = new Swiper(section, {
            navigation: {
              prevEl: '.slider-prev',
              nextEl: '.slider-next',
            },
            pagination: {
              el: '.slider-pagination',
              type: 'bullets',
              clickable: true,
            },
            autoplay: {
              enabled: slideshowAutoplay,
              disableOnInteraction: false
            },
            loop: true,
            observer: true,
          });
        } catch (e) {
            console.log('Swiper JS is not defined');
            console.log(e);
        }
    }

    function slideShowBg(slideshow) {

      const firstSlideIndex = slideshow.swiper.activeIndex;
      const firstSlide = slideshow.swiper.slides[firstSlideIndex];
      const firstSlideBg = firstSlide.querySelector('.hero-container').dataset.bg;
      const slideOuterBg = slideshow.closest('.slideshow-wrapper').dataset.outerBg;
      const firstSlideColorScheme = firstSlide.querySelector('.hero-container').dataset.colorScheme;

      const parentContainer = slideshow.parentElement;
      const parentSection = parentContainer.closest('.slideshow-section');
      const transparentHeader = document.querySelector('.transparent-header');
      const transparentHeaderSection = parentContainer.classList.contains('allow-transparent-header');
      const transparentHeaderFullSection = parentContainer.classList.contains('full-width-slideshow');


      if(transparentHeader && transparentHeaderSection){
        transparentHeader.querySelector('.content-container').classList.add('text-inherit');
        if (transparentHeader && transparentHeader.querySelector('.bottom-menu-content')) {
          transparentHeader.querySelector('.bottom-menu-content').classList.add('text-inherit');
        }
        if(parentSection.parentElement.firstElementChild === parentSection){
          if(transparentHeaderFullSection){
            transparentHeader.setAttribute('data-slide-bg',firstSlideBg);
          }else{
            transparentHeader.setAttribute('data-slide-bg',slideOuterBg);
          }
        }else{
          if(transparentHeader && !transparentHeader.classList.contains('section-allow')){
            transparentHeader.removeAttribute('data-slide-bg');
          }
        }
      }
      slideshow.setAttribute('data-bg-active',firstSlideBg);
      const slideshowClasses = slideshow.classList;
      for (let i = 0; i < slideshowClasses.length; i++) {
        if (slideshowClasses[i].includes('color-scheme')) {
            if(slideshowClasses[i] != firstSlideColorScheme){
              slideshow.classList.remove(slideshowClasses[i])
              slideshow.classList.add(firstSlideColorScheme)
            }
        }else{
          slideshow.classList.add(firstSlideColorScheme)
        }
      }
    }

    window.addEventListener('load', function(){
        setBanner();
    });
    window.addEventListener('resize', function(){
        setBanner();
    });
    document.addEventListener('shopify:section:load', function(){
        setBanner();
    });
    document.addEventListener('shopify:section:reorder', function(){
        setBanner();
    });
        
    function setBanner(){
        const bannerWrapper = document.querySelectorAll('.banner-wrapper');
        for (let i = 0; i < bannerWrapper.length; i++) {
            const bannerWrapperInner = bannerWrapper[i].querySelector('.inner-container');
            const aspectRatioDecimal = bannerWrapper[i].dataset.ratio * 1;
            const elementId = bannerWrapper[i];
            setBannerHeight(bannerWrapperInner, aspectRatioDecimal, elementId);

            const parentContainer = bannerWrapper[i].parentElement;
            const bannerBg = parentContainer.parentElement.dataset.bg;
            const parentSection = parentContainer.closest('.banner-section');
            const transparentHeader = document.querySelector('.transparent-header');
            const transparentHeaderSection = parentContainer.classList.contains('allow-transparent-header');
            
            if(transparentHeader && transparentHeaderSection){
              if(parentSection.parentElement.firstElementChild === parentSection){
                transparentHeader.setAttribute('data-slide-bg',bannerBg);
              }
            }else{
              if(transparentHeader && !transparentHeader.classList.contains('section-allow')){
                transparentHeader.removeAttribute('data-slide-bg');
              }
            }
        }
        
    }

    function setBannerHeight(bannerWrapperInner, aspectRatioDecimal, elementId){
        const height = calculateHeightPixels(aspectRatioDecimal, elementId);
        bannerWrapperInner.style.minHeight = height + 'px';
    }

    function calculateHeightPixels(aspectRatioDecimal, elementId) {
        const widthElement = elementId.getBoundingClientRect().width;
        const roundedAspectRatio = aspectRatioDecimal;
        const height = Math.round(widthElement / roundedAspectRatio);
        return height;
    }

    document.addEventListener('DOMContentLoaded', sectionBeforeAfter);
    document.addEventListener('shopify:section:load', sectionBeforeAfter);
    function sectionBeforeAfter(){

      const beforeAfterSections = document.querySelectorAll('.before-after-section');
      for(let i=0; i < beforeAfterSections.length; i++){
        const beforeAFterSection = beforeAfterSections[i];
        const beforeAFterContainer = beforeAFterSection.querySelector('.before-after-container');
        const revealer = beforeAFterSection.querySelector('.revealer');
        let scrolling = false;

        revealer.addEventListener('mousedown',function(){
          scrolling = true;
          revealer.classList.add('scrolling');
        });
        document.body.addEventListener('mouseup',function(){
            scrolling = false;
            revealer.classList.remove('scrolling');
        });
        document.body.addEventListener('mouseleave',function(){
            scrolling = false;
            revealer.classList.remove('scrolling');
        });
        document.body.addEventListener('mousemove',function(e){
            if (!scrolling) return;
            let x = e.pageX;
            x -= beforeAFterContainer.getBoundingClientRect().left;
            let percentage = (x / beforeAFterContainer.offsetWidth) * 100;
            beforeAfterScrollIt(percentage);
        });

        function beforeAfterScrollIt(percentage){
            let transform = Math.max(0, Math.min(percentage, 100));
            beforeAFterContainer.style.setProperty('--before-after', transform + "%");
        }

        initialRevealerPosition = beforeAFterContainer.dataset.initialDrag;
        beforeAfterScrollIt(initialRevealerPosition);

        revealer.addEventListener('touchstart',function(event){
            event.preventDefault();
            scrolling = true;
            revealer.classList.add('scrolling');
        });
        revealer.addEventListener('touchend',function(){
            scrolling = false;
            revealer.classList.remove('scrolling');
        });
        revealer.addEventListener('touchcancel',function(){
            scrolling = false;
            revealer.classList.remove('scrolling');
        });
        revealer.addEventListener('touchmove',function(e){
            if (!scrolling) return;
            let x = e.touches[0].pageX;
            x -= beforeAFterContainer.getBoundingClientRect().left;
            let percentage = (x / beforeAFterContainer.offsetWidth) * 100;
            beforeAfterScrollIt(percentage); 
        });
      }
    }
    
    document.addEventListener('DOMContentLoaded', setCountDown);
    document.addEventListener('shopify:section:load', setCountDown);
    function setCountDown() {
      const countDowns = document.querySelectorAll('.count-down-section');
      for (let i = 0; i < countDowns.length; i++) {
        const countDown = countDowns[i];
        const countDownData = countDown.querySelector('.count-down-data');

        const inputMonth = countDownData.dataset.month;
        const inputDate = countDownData.dataset.date;
        const inputYear = countDownData.dataset.year;

        const countDownDate = new Date(inputYear, inputMonth - 1, inputDate).getTime();
        const current = new Date().getTime();
        if (countDownDate >= current) {
          const myfunc = setInterval(function () {
            const now = new Date().getTime();
            const timeleft = countDownDate - now;

            const days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
            const hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((timeleft % (1000 * 60)) / 1000);

            const dayField = countDown.querySelector('[data-type="days"]');
            const hourField = countDown.querySelector('[data-type="hours"]');
            const minuteField = countDown.querySelector('[data-type="mins"]');
            const secondField = countDown.querySelector('[data-type="secs"]');
            // const endMessage = countDown.querySelector('.end-message');

            dayField.innerHTML = days;
            hourField.innerHTML = hours;
            minuteField.innerHTML = minutes;
            secondField.innerHTML = seconds;

            if (timeleft < 0) {
              clearInterval(myfunc);
              dayField.innerHTML = '';
              hourField.innerHTML = '';
              minuteField.innerHTML = '';
              secondField.innerHTML = '';
              // endMessage.innerHTML = 'TIME UP!!';
            }
          }, 1000);
        }
      }
    }

    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="language_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('ul'),
        };

        this.toggleDropdownHandler = this.toggleDropdown.bind(this);
        this.closeSelectorHandler = this.closeSelector.bind(this);
        this.openSelectorHandler = this.openSelector.bind(this);
        this.onContainerKeyUpHandler = this.onContainerKeyUp.bind(this);
        this.onItemClickHandler = this.onItemClick.bind(this);
        this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClickHandler));

        this.isPanelVisible = false;
    
        if (window.matchMedia('(max-width: 1023px)').matches) {
          this.bindCountryLanguageDropdown();
        } else {
          this.bindClassFunction();
        }
    
        window.addEventListener('resize', () => {
          if (window.matchMedia('(max-width: 1023px)').matches) {
            this.unbindClassFunction();
            this.bindCountryLanguageDropdown();
          } else {
            this.unbindCountryLanguageDropdown();
            this.bindClassFunction();
          }
        });
      }
    
      bindCountryLanguageDropdown() {
        this.isPanelVisible = false;
        this.elements.panel.style.paddingTop = ""; 
        this.elements.panel.style.paddingBottom = "";
        this.elements.panel.style.height = "";
        this.elements.button.addEventListener('click', this.toggleDropdownHandler);
      }
    
      unbindCountryLanguageDropdown() {
        this.elements.button.removeEventListener('click', this.toggleDropdownHandler); 
      }
    
      bindClassFunction() {
        this.elements.button.addEventListener('click', this.openSelectorHandler);
        this.addEventListener('keyup', this.onContainerKeyUpHandler);
        document.addEventListener('click', this.closeSelectorHandler);

        if (!window.matchMedia('(max-width: 1023px)').matches) {
          
          window.addEventListener('scroll', () => {
            this.elements.button.setAttribute('aria-expanded', false);
            this.elements.panel.setAttribute('hidden', true);
          });
        }
      }
    
      unbindClassFunction() {
        this.elements.button.removeEventListener('click', this.openSelectorHandler);
        this.removeEventListener('keyup', this.onContainerKeyUpHandler); 
        document.removeEventListener('click', this.closeSelectorHandler); 

        if (!window.matchMedia('(max-width: 1023px)').matches) {
          window.removeEventListener('scroll', this.closeScrollHandler);
        }
      }
      

      toggleDropdown(){
        this.isPanelVisible = !this.isPanelVisible;
        if (this.isPanelVisible) {
          const buttonDropdownChilds = this.elements.panel.querySelectorAll('li');
          let dropDownHeight = 0;
          for (let i = 0; i < buttonDropdownChilds.length; i++) {
            const buttonDropdownChild = buttonDropdownChilds[i];
            const dropdownChildComputedStyle = window.getComputedStyle(buttonDropdownChild);
            const dropdownChildHeight = parseInt(dropdownChildComputedStyle.getPropertyValue('height'), 10);
            const dropdownChildMarginBottom = parseInt(dropdownChildComputedStyle.getPropertyValue('margin-bottom'), 10);
            dropDownHeight = dropDownHeight + dropdownChildHeight + dropdownChildMarginBottom;
          }
          dropDownHeight += 48;
          this.elements.panel.toggleAttribute('hidden');
          let popupPadding;
          if (window.matchMedia('(max-width: 1023px)').matches) {
            popupPadding = 8;
          }else{
            popupPadding = 24;
          }
          this.elements.panel.style.paddingTop = popupPadding + 'px';
          this.elements.panel.style.paddingBottom = popupPadding + 'px';
          this.elements.panel.style.height = dropDownHeight + 'px';
          this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
        }else{
          this.elements.panel.style.paddingTop = "";
          this.elements.panel.style.paddingBottom = "";
          this.elements.panel.style.height = ""; 
          setTimeout(() => {
            this.elements.button.setAttribute('aria-expanded', 'false');
            this.elements.panel.setAttribute('hidden', true);
          }, 300);
        }
      }
    
      hidePanel() {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }
    
      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;
        this.hidePanel();
        this.elements.button.focus();
      }
    
      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }
    
      openSelector() {
        setTimeout(() => {
          // this.elements.panel.focus();
        }, 100);
        this.elements.panel.toggleAttribute('hidden');
        this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
      }
    
      closeSelector(event) {
        if (!window.matchMedia('(max-width: 1023px)').matches) {
          const isButton = event.target === this.elements.button;
          const isInsidePanel = this.elements.panel.contains(event.target);
          const isInsideDropdown = this.contains(event.target);
          if (!isButton && !isInsidePanel && !isInsideDropdown) {
            this.isPanelVisible = false;
            this.hidePanel();
          }
        }
      }
    }
    customElements.define('localization-form', LocalizationForm);  

    let isKeyboardFocus = false;
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Tab') {
        isKeyboardFocus = true;
      }
    });

    document.addEventListener('mousedown', function() {
      isKeyboardFocus = false;
    });

    class FilterForm extends HTMLElement {
      constructor() {
        super();
        const filterForm = this.querySelector('form');
        filterForm.addEventListener('input', this.handleFormChange.bind(this));
        
      }

      handleFormChange(event) {
        this.handleCheckboxChange(event);
      }

      handleCheckboxChange(event){
        if(event.target.type === 'checkbox'){
          const root_url = this.dataset.url;
          if (event.target.checked) {
            if(root_url.includes('?')){
              const url = root_url + '&' + event.target.name + '=' + event.target.value.replace(" ", "+");
              this.setUrl(url);
            }else{
              const url = root_url + '?' + event.target.name + '=' + event.target.value.replace(" ", "+");
              this.setUrl(url); 
            }
          }else{
            const urlQuery = root_url.split('?');
            const queryRoot = urlQuery[0];
            const queryParamString = urlQuery[1];
            const queryParams = queryParamString.split('&');
            const urlRemove = event.target.name + '=' + event.target.value.replace(" ", "+");
            let url = queryRoot;
            let firstQueryParam = true;
            for (let i = 0; i < queryParams.length; i++) {
              if(queryParams[i] == urlRemove){
                continue
              }
              if(firstQueryParam){
                url = url + '?' + queryParams[i];
                firstQueryParam = false;
              }else{
                url = url + '&' + queryParams[i]; 
              }
            }
            
            this.setUrl(url);
          }
        }
      }

      setUrl(url, sort_by){
        this.dataset.url = url;
        document.querySelector('.load-wrapper').setAttribute('data-loading', 'loading');
        this.fetchNewDoc(url, sort_by);
      }

      fetchNewDoc(url, sort_by) {
        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            window.history.replaceState({}, '', url);
            this.renderFilter(html);
            this.renderPage(html);
            const sortByWrapper = this.closest('.search-filter-wrapper, .product-filter-wrapper');
            if (sort_by) {
              setTimeout(() => {
                const sortByEl = sortByWrapper.querySelector('.result-container .sort-by');
                if (sortByEl) {
                  sortByEl.focus();
                  if (isKeyboardFocus) {
                    sortByEl.classList.add('select-keyboard-focused');
                  }
                }
              }, 0);
            }
          });
      }

      renderFilter(html){
        const activeFilterWrappers = ['.filter-head', '.active-filters'];

        activeFilterWrappers.forEach((wrapper) => {
          const activeFilter = html.querySelector(wrapper); 
          if (!activeFilter) return; 
          document.querySelector(wrapper).innerHTML = activeFilter.innerHTML;
        });


        const filterDisplays = document.querySelectorAll('.filter-group-display');
        
        filterDisplays.forEach((filterDisplay) => {
          const displayId = filterDisplay.id;

          const displayHead = html.getElementById(displayId).querySelector('.filter-group-display__header'); 
          if (displayHead){
            document.getElementById(displayId).querySelector('.filter-group-display__header').innerHTML = displayHead.innerHTML; 
          } 

          const displayList = html.getElementById(displayId).querySelector('.filter-group-display__list'); 
          if (displayList){
            const filterList = document.getElementById(displayId).querySelector('.filter-group-display__list');
            filterList.innerHTML = displayList.innerHTML;
             if(filterList.classList.contains('filter-group-display__list-color')){
               filterColorImage();
             }
          } 
        });

        const range = this.querySelector(".price-slider .price-progress");
        const priceMin = this.querySelector('.price-min');
        const priceMax = this.querySelector('.price-max');
        const rangeMin = this.querySelector('.price-range-min');
        const rangeMax = this.querySelector('.price-range-max');
        const newRangeMin = html.querySelector('.price-range-min');
        const newRangeMax = html.querySelector('.price-range-max');
        const priceRangeFilter = this.querySelector('price-range');
        if(priceRangeFilter){
          priceRangeFilter.resetPriceRange(range, priceMin, priceMax, rangeMin, rangeMax, newRangeMin, newRangeMax);
        }
      }

      renderPage(html){
        const pageContents = ['.result-container', '.pagination-wrapper-bottom', '.pagination-wrapper-top'];

        pageContents.forEach((content) => {
          const pageContent = html.querySelector(content);
          if (!pageContent) return; 
          document.querySelector(content).innerHTML = pageContent.innerHTML;
          if(content == '.result-container'){
            handleQuickView();
          }
        });
        document.querySelector('.load-wrapper').removeAttribute('data-loading'); 
      }
    }
    customElements.define('filter-form', FilterForm);

    $(document).ready(function() {
      filterColorImage();
    });

    function filterColorImage(){
      $('.filter-color-image, .variant-color-image').each(function() {
          let img = $(this); // Current image in the loop
          let canvas = $('<canvas></canvas>')[0]; // Create a new canvas for each image
          let context = canvas.getContext('2d');

          // Function to check if an image exists
          function checkImageExists(imageUrl, callback) {
              var image = new Image();
              image.onload = function() {
                  callback(true);
              };
              image.onerror = function() {
                  callback(false);
              };
              image.src = imageUrl;
          }

          // Load the image and perform color analysis
          checkImageExists(img.attr('src'), function(exists) {
              if (!exists) {
                img.remove();
              } else {
                img.on('load', function() {
                    // Set canvas dimensions to the image's natural dimensions
                    canvas.width = this.naturalWidth;
                    canvas.height = this.naturalHeight;

                    context.drawImage(this, 0, 0, this.naturalWidth, this.naturalHeight);

                    let imageData = context.getImageData(0, 0, canvas.width, canvas.height);
                    let data = imageData.data;

                    let colorCount = {};

                    // Count colors
                    for (let i = 0; i < data.length; i += 4) {
                        let color = data[i] + ',' + data[i+1] + ',' + data[i+2];
                        colorCount[color] = (colorCount[color] || 0) + 1;
                    }

                    let mostFrequentColor = '';
                    let maxCount = 0;

                    // Determine the most frequent color
                    for (let color in colorCount) {
                        if (colorCount[color] > maxCount) {
                            maxCount = colorCount[color];
                            mostFrequentColor = color;
                        }
                    }

                    // Output or use the most used color
                    let rgbArray = mostFrequentColor.split(',');
                    let mostUsedRed = parseInt(rgbArray[0]);
                    let mostUsedGreen = parseInt(rgbArray[1]);
                    let mostUsedBlue = parseInt(rgbArray[2]);

                    let colorBrightness = ((mostUsedRed * 299) + (mostUsedGreen * 587) + (mostUsedBlue * 114)) / 1000;
                    let checkColor = colorBrightness > 128 ? '#000000' : '#ffffff';

                    let closestLabel = $(this).closest('label');
                    if (closestLabel.hasClass('checkbox-label')) {
                        closestLabel.css('--check-color', checkColor);
                    } else {
                        closestLabel.css('--strike-color', checkColor);
                    }
                    canvas = null;
                });

                // Trigger the image load event
                img.attr('src', img.attr('src'));
              }
          });
      });
    }


    class FilterRemove extends HTMLElement {
      constructor() {
        super();
        const filterRemove = this.querySelector('a');
        filterRemove.addEventListener('click', this.handleFilterRemove.bind(this));
        
      }

      setRemoveUrl(url){
        this.querySelector('a').setAttribute('href', url)
      }

      handleFilterRemove(event){
        event.preventDefault();
        const url = this.querySelector('a').getAttribute('href');
        const filterForm = this.closest('filter-form');
        filterForm.setUrl(url); 
      }
    }
    customElements.define('filter-remove', FilterRemove); 


    class SortFilter extends HTMLElement {
      constructor() {
        super();
        this.attachListeners();
      }

      attachListeners() {
        const sortSelect = this.querySelector('select');
        if (sortSelect) {
          sortSelect.addEventListener('change', this.updateSort.bind(this));
          this.handleFocus(sortSelect);
        }
      }

      handleFocus(selectElement) {
        selectElement.addEventListener('focus', function() {
          if (isKeyboardFocus) {
            selectElement.classList.add('select-keyboard-focused');
          }
        });
    
        selectElement.addEventListener('blur', function() {
          selectElement.classList.remove('select-keyboard-focused');
        });
      }

      updateSort() {
        const sortSelect = this.querySelector('select');
        if (sortSelect) {
          const sortOptions = sortSelect.options;
          for (let i = 0; i < sortOptions.length; i++) {
            sortOptions[i].removeAttribute("selected");
          }
    
          const selectedOption = sortOptions[sortSelect.selectedIndex];
          selectedOption.setAttribute("selected", "");
    
          const sortValue = sortSelect.value;
          this.handleSortChange(sortValue);
        }
      }

      handleSortChange(sortValue) {
        const filterForm = document.querySelector('filter-form');
        const root_url = filterForm.dataset.url;
        if (root_url.includes('?')) {
          const urlQuery = root_url.split('?');
          const queryRoot = urlQuery[0];
          let url = queryRoot;
          const queryParamString = urlQuery[1];
          if (queryParamString.includes('sort_by')) {
            const queryParams = queryParamString.split('&');
            let prefix = '';
            for (let i = 0; i < queryParams.length; i++) {
              prefix = (i == 0) ? '?' : '&';
              const queryparamArrray = queryParams[i].split('=');
              const paramName = queryparamArrray[0];
              if (paramName === 'sort_by') {
                url = url + prefix + 'sort_by=' + sortValue;
              } else {
                url = url + prefix + queryParams[i];
              }
            }
          } else {
            url = root_url + '&sort_by=' + sortValue;
          }
          filterForm.setUrl(url, true);
        } else {
          const url = root_url + '?sort_by=' + sortValue;
          filterForm.setUrl(url, true);
        }
      }

      connectedCallback() {
        this.attachListeners();
      }
    
      disconnectedCallback() {
        const sortSelect = this.querySelector('select');
        if (sortSelect) {
          sortSelect.removeEventListener('change', this.updateSort.bind(this));
          sortSelect.removeEventListener('focus', this.handleFocus.bind(this));
          sortSelect.removeEventListener('blur', this.handleFocus.bind(this));
        }
      }
    }
    customElements.define('sort-filter', SortFilter); 


    class PriceRange extends HTMLElement {
      constructor() {
        super();
        const filterForm = this.closest('form');
        const range = this.querySelector(".price-slider .price-progress");
        const priceMin = this.querySelector('.price-min');
        const priceMax = this.querySelector('.price-max');
        const rangeMin = this.querySelector('.price-range-min');
        const rangeMax = this.querySelector('.price-range-max');
        let priceGap = 0;
        window.addEventListener('load', this.handlePriceRangeOnLoad.bind(this, range, rangeMin, rangeMax));
        priceMax.addEventListener('input', this.handleMaxPriceChange.bind(this, range, priceMin, priceMax, rangeMax, priceGap));
        priceMin.addEventListener('input', this.handleMinPriceChange.bind(this, range, priceMin, priceMax, rangeMin, rangeMax, priceGap));
        rangeMin.addEventListener('input', this.handleMinRangeChange.bind(this, range, priceMin, priceMax, rangeMin, rangeMax, priceGap));
        rangeMax.addEventListener('input', this.handleMaxRangeChange.bind(this, range, priceMin, priceMax, rangeMin, rangeMax, priceGap));
        priceMin.addEventListener('change', this.handleMinPriceUpdate.bind(this, priceMin, priceMax, rangeMin, rangeMax, priceGap));
        priceMax.addEventListener('change', this.handleMaxPriceUpdate.bind(this, priceMin, priceMax, rangeMin, rangeMax, priceGap));
        rangeMin.addEventListener('change', this.handlePriceUpdate.bind(this, priceMin, priceMax));
        rangeMax.addEventListener('change', this.handlePriceUpdate.bind(this, priceMin, priceMax));

      }

      handlePriceUpdate(priceMin, priceMax){
        const priceMinValue = priceMin.value;
        const priceMaxValue = priceMax.value;
        const priceMinName = priceMin.name;
        const priceMaxName = priceMax.name;
        const priceMinFilter = priceMinName + '=' + priceMinValue;
        const priceMaxFilter = priceMaxName + '=' + priceMaxValue;
        const filterForm = document.querySelector('filter-form');

        const root_url = filterForm.dataset.url;
        if (root_url.includes(priceMinName) || root_url.includes(priceMaxName)) {
          const urlQuery = root_url.split('?');
          const queryRoot = urlQuery[0];
          const queryParamString = urlQuery[1];
          const queryParams = queryParamString.split('&');
          let url = queryRoot;
          let firstQueryParam = true;
          for (let i = 0; i < queryParams.length; i++) {
            const queryParam = queryParams[i].split('=');
            const queryParamName = queryParam[0];
            if(queryParamName == priceMinName){
              if(firstQueryParam){
                url = url + '?' + priceMinFilter;
                firstQueryParam = false;
              }else{
                url = url + '&' + priceMinFilter; 
              }
            }else if (queryParamName == priceMaxName){
              if(firstQueryParam){
                url = url + '?' + priceMaxFilter;
                firstQueryParam = false;
              }else{
                url = url + '&' + priceMaxFilter; 
              }
            }else{
              if(firstQueryParam){
                url = url + '?' + queryParams[i];
                firstQueryParam = false;
              }else{
                url = url + '&' + queryParams[i]; 
              }
            }
          }
          
          filterForm.setUrl(url); 
        }else{
          if(root_url.includes('?')){
            const url = root_url + '&' + priceMinFilter + '&' + priceMaxFilter;
            filterForm.setUrl(url);
          }else{
            const url = root_url + '?' + priceMinFilter + '&' + priceMaxFilter;
            filterForm.setUrl(url); 
          }

        }

        
      }

      handleMinPriceUpdate(priceMin, priceMax, rangeMin, rangeMax, priceGap){
        
        let minPrice = parseInt(priceMin.value),
            maxPrice = Math.ceil(parseFloat(priceMax.value));
        let minPriceValue = Math.ceil(parseFloat(priceMin.value));
        if (maxPrice - minPrice >= priceGap && minPriceValue <= rangeMax.max && minPriceValue >= 0){
          priceMin.value = minPrice;
          this.toggleErrorMessage(priceMin, priceMax, rangeMax, priceGap);
          this.handlePriceUpdate(priceMin, priceMax);
        }else{
          this.toggleErrorMessage(priceMin, priceMax, rangeMax, priceGap);
        }
      }
      handleMaxPriceUpdate(priceMin, priceMax, rangeMin, rangeMax, priceGap){
        let minPrice = parseInt(priceMin.value),
            maxPrice = Math.ceil(parseFloat(priceMax.value));
        if (maxPrice - minPrice >= priceGap && maxPrice <= rangeMax.max && maxPrice >= 0){
          priceMax.value = maxPrice;
          this.toggleErrorMessage(priceMin, priceMax, rangeMax, priceGap);
          this.handlePriceUpdate(priceMin, priceMax);
        }else{
          this.toggleErrorMessage(priceMin, priceMax, rangeMax, priceGap);
        }
      }

      handlePriceRangeOnLoad(range, rangeMin, rangeMax){
        let minPrice = parseInt(rangeMin.value),
            maxPrice = parseInt(rangeMax.value);
        let leftPercentage = (minPrice / rangeMin.max) * 100;
        let rightPercentage = 100 - (maxPrice / rangeMax.max) * 100;
        range.style.left = `calc(${leftPercentage}% - 8px)`;
        range.style.right = `calc(${rightPercentage}% - 8px)`;
      }

      resetPriceRange(range, priceMin, priceMax, rangeMin, rangeMax, newRangeMin, newRangeMax){
        let minPrice = parseInt(newRangeMin.value),
            maxPrice = parseInt(newRangeMax.value);
        let leftPercentage = (minPrice / newRangeMax.max) * 100;
        let rightPercentage = 100 - (maxPrice / newRangeMax.max) * 100;
        priceMin.value = minPrice;
        priceMax.value = maxPrice;
        rangeMin.value = minPrice;
        rangeMax.value = maxPrice;
        range.style.left = `calc(${leftPercentage}% - 8px)`;
        range.style.right = `calc(${rightPercentage}% - 8px)`;
      }

      handleMaxRangeChange(range, priceMin, priceMax, rangeMin, rangeMax, priceGap){
        let minVal = parseInt(rangeMin.value),
        maxVal = parseInt(rangeMax.value);
        if (maxVal - minVal < priceGap) {
          rangeMax.value = minVal + priceGap;
          priceMax.value = parseInt(rangeMax.value);
          let rightPercentage = 100 - (parseInt(rangeMax.value) / rangeMax.max) * 100;
          range.style.right = `calc(${rightPercentage}% - 8px)`;
          this.toggleErrorMessage(priceMin, priceMax, rangeMax, priceGap);
        } else {
          this.setPriceAndProgress(range, priceMin, priceMax, rangeMin, rangeMax, minVal, maxVal, priceGap);
        }
      }
      handleMinRangeChange(range, priceMin, priceMax, rangeMin, rangeMax, priceGap){
        let minVal = parseInt(rangeMin.value),
        maxVal = parseInt(rangeMax.value);

        if (maxVal - minVal < priceGap) {
          rangeMin.value = maxVal - priceGap;
          priceMin.value = parseInt(rangeMin.value);
          let leftPercentage = (parseInt(rangeMin.value) / rangeMin.max) * 100 ;
          range.style.left = `calc(${leftPercentage}% - 8px)`;
          this.toggleErrorMessage(priceMin, priceMax, rangeMax, priceGap);
        } else {
          this.setPriceAndProgress(range, priceMin, priceMax, rangeMin, rangeMax, minVal, maxVal, priceGap);
        }
      }

      setPriceAndProgress(range, priceMin, priceMax, rangeMin, rangeMax, minVal, maxVal, priceGap){
        priceMin.value = minVal;
        priceMax.value = maxVal;
        let leftPercentage = (minVal / rangeMin.max) * 100;
        let rightPercentage = 100 - (maxVal / rangeMax.max) * 100;
        range.style.left = `calc(${leftPercentage}% - 8px)`;
        range.style.right = `calc(${rightPercentage}% - 8px)`;
        this.toggleErrorMessage(priceMin, priceMax, rangeMax, priceGap);
      }

      handleMaxPriceChange(range, priceMin, priceMax, rangeMax, priceGap){
        let minPrice = parseInt(priceMin.value),
            maxPrice = Math.ceil(parseFloat(priceMax.value));
        if (maxPrice - minPrice >= priceGap && maxPrice <= rangeMax.max && maxPrice >= 0) {
          rangeMax.value = maxPrice;
          let rightPercentage = 100 - (maxPrice / rangeMax.max) * 100;
          range.style.right = `calc(${rightPercentage}% - 8px)`;
          this.toggleErrorMessage(priceMin, priceMax, rangeMax, priceGap);
        }else{
          this.toggleErrorMessage(priceMin, priceMax, rangeMax, priceGap);
        }
      }
      handleMinPriceChange(range, priceMin, priceMax, rangeMin, rangeMax, priceGap){
        let minPrice = parseInt(priceMin.value),
            maxPrice = Math.ceil(parseFloat(priceMax.value));
        let minPriceValue = Math.ceil(parseFloat(priceMin.value));

        if (maxPrice - minPrice >= priceGap && minPriceValue <= rangeMax.max && minPriceValue >= 0) {
          rangeMin.value = minPrice;
          let leftPercentage = (minPrice / rangeMin.max) * 100;
          range.style.left = `calc(${leftPercentage}% - 8px)`;
          this.toggleErrorMessage(priceMin, priceMax, rangeMax, priceGap);
        }else{
          this.toggleErrorMessage(priceMin, priceMax, rangeMax, priceGap);
        }
      }

      toggleErrorMessage(priceMin, priceMax, rangeMax, priceGap){
        let minPrice = parseInt(priceMin.value),
            maxPrice = Math.ceil(parseFloat(priceMax.value));
        let minPriceValue = Math.ceil(parseFloat(priceMin.value));
        const fromErrorEl = this.querySelector('.filter-price-error.from-error');
        const toErrorEl = this.querySelector('.filter-price-error.to-error');
        const bothErrorEl = this.querySelector('.filter-price-error.both-error');
        if (maxPrice - minPrice >= priceGap && minPriceValue <= rangeMax.max && maxPrice <= rangeMax.max && minPriceValue >= 0 && maxPrice >= 0) {
          fromErrorEl.style.display = 'none';
          bothErrorEl.style.display = 'none';
          toErrorEl.style.display = 'none';
        }else if(minPriceValue < 0 || maxPrice < 0){
          fromErrorEl.style.display = 'none';
          toErrorEl.style.display = 'none';
          bothErrorEl.style.display = 'block';
        }else if(minPriceValue > maxPrice) {
          toErrorEl.style.display = 'none';
          bothErrorEl.style.display = 'none';
          fromErrorEl.style.display = 'block';
        }else if(maxPrice > rangeMax.max){
          fromErrorEl.style.display = 'none';
          bothErrorEl.style.display = 'none';
          toErrorEl.style.display = 'block';
        }
      }

    }
    customElements.define('price-range', PriceRange); 


    class CollapsibleContent extends HTMLElement {
      constructor() {
        super();
        const toggle = this.querySelector('.collapsible-toggle');
        window.addEventListener('load', this.handleCollapseState.bind(this));
        window.addEventListener('resize', this.handleCollapseState.bind(this));
        document.addEventListener('shopify:section:load', this.handleCollapseState.bind(this));
        toggle.addEventListener('click', this.handleCollapse.bind(this));
        
      }
      handleCollapseState(){
        const content = this.querySelector('.collapsible-content');
        if(this.getAttribute('aria-expanded') == "true"){
          content.style.height = content.querySelector('.collapsible-content-inner').scrollHeight + 'px';
        }else{
          content.style.height = '0px';
        }
      }
      handleCollapse() {
        const toggle = this.querySelector('.collapsible-toggle');
        const content = this.querySelector('.collapsible-content');
        
        const parentGroup = this.closest('[data-behaviour="group"]');
    
        if (parentGroup) {
          const otherCollapsibles = parentGroup.querySelectorAll('collapsible-content');
          otherCollapsibles.forEach(collapsible => {
            if (collapsible !== this) {
              collapsible.close();
            }
          });
        }
    
        if (content.style.height === '0px') {
          content.style.height = content.scrollHeight + 'px';
          this.setAttribute('aria-expanded', true);
        } else {
          content.style.height = '0px';
          this.setAttribute('aria-expanded', false);
        }
      }
    
      close() {
        const content = this.querySelector('.collapsible-content');
        content.style.height = '0px';
        this.setAttribute('aria-expanded', false);
      }

    }
    customElements.define('collapsible-content', CollapsibleContent);

    document.addEventListener('DOMContentLoaded', thumbProductModel);
    document.addEventListener('shopify:section:load', thumbProductModel);
    function thumbProductModel(){
      var thumb_image = document.querySelectorAll('.thumb-image');
      for (var i = 0; i < thumb_image.length; i++) {
        thumb_image[i].addEventListener('click', function (event) {
          var model = document.querySelector('.product-model-inner');
          model.style.display = 'block';
        });
      }
      var model_close = document.querySelector('.product-model-close');
      model_close.addEventListener('click', function (event) {
        var model = document.querySelector('.product-model-inner');
        model.style.display = 'none';
      });
    }

    function trapFocus(event, trapcontainer) {
      const focusableElements = trapcontainer.querySelectorAll(
      'a[href], button:not([tabindex="-1"]), textarea, input[type="text"], input[type="radio"], input[type="tel"], input[type="checkbox"], select'
      );
      const firstFocusableElement = focusableElements[0];
      const lastFocusableElement = focusableElements[focusableElements.length - 1];
      const isTabPressed = event.key === 'Tab' || event.keyCode === 9;

      if (!isTabPressed) {
        return;
      }

      if (event.shiftKey) {
        // If Shift + Tab is pressed, focus the last focusable element when the first focusable element is reached
        if (document.activeElement === firstFocusableElement) {
            event.preventDefault();
            lastFocusableElement.focus();
        }
      } else {
        // If Tab is pressed, focus the first focusable element when the last focusable element is reached
        if (document.activeElement === lastFocusableElement) {
            event.preventDefault();
            firstFocusableElement.focus();
        }
      }
    }

    document.addEventListener('shopify:section:load', countryListFocus);
    document.addEventListener('DOMContentLoaded', countryListFocus);
    function countryListFocus(){
      var countryListEl = document.getElementById('CountryList');
      if(countryListEl){
        countryListEl.addEventListener('keydown', function(event) {
          trapFocus(event, countryListEl);
        });
      }
    }

    document.addEventListener('shopify:section:load', addressFormFocus);
    document.addEventListener('DOMContentLoaded', addressFormFocus);
    function addressFormFocus(){
      var addressFormArr = document.querySelectorAll('.address-form-popup-wrapper');
      for (let i = 0; i < addressFormArr.length; i++) {
        let addressForm = addressFormArr[i];
        addressForm.addEventListener('keydown', function(event) {
          trapFocus(event, addressForm);
        });
      }
    }

    window.addEventListener('pageshow', function(event) {
      if (event.persisted) {
        updateCartCount();
      }
    });
    function updateCartCount() {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          // Update the cart count element
          const cartCountElement = document.querySelector('.cart-count');
          if (cartCountElement) {
            cartCountElement.textContent = cart.item_count;
          }
          
          const productSections = document.querySelectorAll('.product-section-wrapper');
          productSections.forEach(section => {
            const productForm = section.querySelector('.shopify-product-form');
            const variantId = productForm.querySelector('[name="id"]').value;
            const cartItems = cart.items;
            let variantQuantity = 0;
            cartItems.forEach(cartItem => {
              const cartItemId = cartItem.variant_id;
              if(cartItemId == variantId) {
                variantQuantity += cartItem.quantity;
              }
            })
            const productCartCountEl = section.querySelector('[data-cart-count]');
            productCartCountEl.setAttribute('data-cart-count', variantQuantity);
          })
        })
        .catch(error => {
          console.error('Error fetching cart data:', error);
        });
    }
    
    window.addEventListener('pageshow', function(event) {
      let productDetails = document.querySelectorAll('.featured-product-section .product-detail');
  
      productDetails.forEach(productDetail => {
        let variantSelector = productDetail.querySelector('variant-selector');
        if (variantSelector) {
          // Do something with the variantSelector, for example:
          let variantSection = variantSelector.dataset.section; 
          function handleSectionResponse() {
            if(this.status === 200) {
              let newProductSection = new DOMParser().parseFromString(this.responseText, 'text/html');
              var newVariantSelector = newProductSection.querySelector('variant-selector');
              variantSelector.innerHTML = newVariantSelector.innerHTML;
            }else{
              console.log(this.statusText)
            }
          }
          const request = new XMLHttpRequest();
          request.addEventListener('load', handleSectionResponse);
          request.open('GET', window.location.pathname + '?section_id=' + variantSection , true);
          request.send();
        }
      });
    });


    document.addEventListener('shopify:section:load', handleQuickView);
    document.addEventListener('shopify:section:unload', handleQuickView);
    document.addEventListener('DOMContentLoaded', handleQuickView);

    let isQuickViewSelected = false;
    let isQuickViewOpen = false;

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:select', (event) => handleSectionEvent(event, quickViewShow, quickViewClose));
      document.addEventListener('shopify:section:deselect', (event) => handleSectionEvent(event, null, quickViewClose));
      document.addEventListener('shopify:section:load', (event) => handleSectionEvent(event, quickViewShow, quickViewClose));
      document.addEventListener('shopify:section:unload', (event) => handleSectionEvent(event, null, quickViewClose));
    }

    function handleQuickView() {
      setTimeout(() => {
        const quickViewSection = document.querySelector('.quick-view-section');
        const quickViewWrappers = document.querySelectorAll('.quick-view-wrapper');
        
        quickViewWrappers.forEach(wrapper => {
          const quickViewButton = wrapper.querySelector('.quick-view-button');
    
          if (quickViewButton) {
            const newButton = quickViewButton.cloneNode(true);
            quickViewButton.parentNode.replaceChild(newButton, quickViewButton);
    
            const setupMode = Shopify.designMode ? setupDesignMode : setupNonDesignMode;
            setupMode(wrapper, quickViewSection, newButton);
          }
        });
          const quickViewModal = quickViewSection
              ? quickViewSection.querySelector('#quick-view-modal')
              : null;
    
        if (quickViewModal) {
          const quickViewCloseBtn = quickViewSection.querySelector('.quick-view-close');
          if (quickViewCloseBtn) {
            const newCloseButton = quickViewCloseBtn.cloneNode(true);
            quickViewCloseBtn.parentNode.replaceChild(newCloseButton, quickViewCloseBtn);
    
            newCloseButton.addEventListener('click', () => quickViewClose(quickViewSection.id));
          }

          if (document.quickViewClickListenerAdded) {
            document.removeEventListener('click', document.quickViewClickListener);
          }
    
          document.quickViewClickListener = (event) => {
            const quickViewCard = quickViewSection.querySelector('.product-page');
            const quickViewCartPopup = document.querySelector('.cart-popup-wrapper');
            const quickViewButtonClicked = event.target.closest('.quick-view-button');
            if (
              (quickViewCard && !quickViewCard.contains(event.target)) &&
              (quickViewCartPopup && !quickViewCartPopup.contains(event.target)) &&
              !quickViewButtonClicked
            ) {
              quickViewClose(quickViewSection.id);
            }
          };

          document.addEventListener('click', document.quickViewClickListener);
          document.quickViewClickListenerAdded = true;
        }
      }, 100);
    }

    function setupDesignMode(wrapper, quickViewSection, quickViewButton) {
      const quickViewModal = quickViewSection.querySelector('#quick-view-modal');
      wrapper.classList.toggle('show', !!quickViewModal);
      if (quickViewModal) bindQuickViewButton(quickViewButton, quickViewSection.id);
    }

    function setupNonDesignMode(wrapper, quickViewSection, quickViewButton) {
      const quickViewModal = quickViewSection.querySelector('#quick-view-modal');
      if (quickViewModal) {
        wrapper.classList.add('show');
        bindQuickViewButton(quickViewButton, quickViewSection.id);
      } else {
        wrapper.remove();
      }
    }

    function bindQuickViewButton(button, sectionId) {
      const newButton = button.cloneNode(true);
      button.parentNode.replaceChild(newButton, button);
    
      newButton.addEventListener('click', () => fetchQuickView(sectionId, newButton));
    }

    function fetchQuickView(sectionId, button) {
      const separator = button.dataset.url.includes('?') ? '&' : '?';
      const fetchId = sectionId.replace('shopify-section-', '');
      const productURL = `${button.dataset.url}${separator}section_id=${fetchId}`;
    
      fetch(productURL)
        .then(response => response.text())
        .then(htmlString => {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = htmlString;

          const fetchedProductGrid = tempDiv.querySelector(`#${sectionId} .product-grid`);
          const fetchedSectionContent = fetchedProductGrid.innerHTML;
          const fetchedProductGridClasses = fetchedProductGrid.className;

          const currentProductGrid = document.querySelector(`#${sectionId} .product-grid`);
          currentProductGrid.innerHTML = fetchedSectionContent;
          currentProductGrid.className = fetchedProductGridClasses;
    
          const quickViewMedia = tempDiv.querySelector(`#${sectionId} .product-medias`);
          productSectionSlider();
          thumbProductModel();
          shopifyXr();
          cleanUpVideoPlayers();
          productForm();
          quantityBtnHandle();
          quantityInputHandle();
    
          if (quickViewMedia) videoPlayerInitialise(`#${quickViewMedia.id}`);
          isQuickViewOpen = true;
          quickViewShow(sectionId);
        })
        .catch(error => console.error('Error loading quick view:', error));
    }

    function quickViewShow(sectionId) {
      const htmlEl = document.querySelector('html');
      const quickView = document.querySelector(`#${sectionId}`);
      const quickViewCard = quickView.querySelector('.product-page');
    
      quickView.classList.add('show');
      htmlEl.classList.add('popup-show');
      if (Shopify.designMode) quickView.classList.add('fade');
    
      setTimeout(() => {
        quickView.classList.add('fade');
        if (!Shopify.designMode) quickViewCard.focus();
      }, 100);
    
      quickViewCard.setAttribute('tabindex', '-1');
      quickViewCard.addEventListener('keydown', (event) => trapFocus(event, quickViewCard));
    }

    function quickViewClose(sectionId) {
      const htmlEl = document.querySelector('html');
      const quickView = document.querySelector(`#${sectionId}`);
      if (Shopify.designMode && isQuickViewSelected) {
        htmlEl.classList.remove('popup-show');
        return;
      }
    
      quickView.classList.remove('fade');
      setTimeout(() => {
        
        if(!isQuickViewSelected){
          quickView.classList.remove('show');
          htmlEl.classList.remove('popup-show');
        }
      }, 400);
    }

    function handleSectionEvent(event, showAction, closeAction = null) {
      const quickViewSection = document.querySelector('.quick-view-section');
      const quickViewModal = event.target.querySelector('#quick-view-modal');
      if (event.target.classList.contains('quick-view-section') && quickViewModal) {
        if (showAction && closeAction){
          if(event.type == 'shopify:section:select'){
            isQuickViewSelected = true;
            isQuickViewOpen = true;
            showAction(quickViewSection.id);
          }else{
            if(isQuickViewSelected){
              isQuickViewOpen = true;
              showAction(quickViewSection.id);
            }
          }
        } else if (closeAction){
          if(event.type == 'shopify:section:deselect'){
            isQuickViewSelected = false;
          }
          isQuickViewOpen = false;
          closeAction(quickViewSection.id);
        }
      } else {
        if (closeAction && isQuickViewOpen && !isQuickViewSelected) {
          isQuickViewSelected = false;
          isQuickViewOpen = false;
          closeAction(quickViewSection.id);
        }
        if(event.type == 'shopify:section:deselect'){
          isQuickViewSelected = true;
        }else if(event.type == 'shopify:section:select' || event.type == 'shopify:section:load'){
          isQuickViewSelected = false;
        }
      }
    }
   /* Desktop hover opens Infinity menu by triggering existing click handlers */
document.addEventListener('mouseover', function (e) {
  if (window.innerWidth < 1024) return;

  const firstBtn = e.target.closest('header .header-inline-nav .first-sub-menu-toggle');
  if (firstBtn) {
    const expanded = firstBtn.getAttribute('aria-expanded') === 'true';
    if (!expanded) firstBtn.click();
    return;
  }

  const secondBtn = e.target.closest('header .header-inline-nav .second-sub-menu-toggle');
  if (secondBtn) {
    const expanded = secondBtn.getAttribute('aria-expanded') === 'true';
    if (!expanded) secondBtn.click();
  }
});

document.addEventListener('mouseleave', function () {
  if (window.innerWidth < 1024) return;
}, true);

document.addEventListener('mouseover', function (e) {
  if (window.innerWidth < 1024) return;

  const insideMenu = e.target.closest('header .header-inline-nav');
  if (insideMenu) return;

  document.querySelectorAll('header .first-sub-menu-toggle[aria-expanded="true"]').forEach((btn) => {
    btn.click();
  });
}, true);
/* Desktop hover for Infinity menu */
document.addEventListener('mouseover', function (e) {
  if (window.innerWidth < 1024) return;

  const firstBtn = e.target.closest('header .first-sub-menu-toggle');
  if (firstBtn) {
    const expanded = firstBtn.getAttribute('aria-expanded') === 'true';
    if (!expanded) firstBtn.click();
    return;
  }

  const secondBtn = e.target.closest('header .second-sub-menu-toggle');
  if (secondBtn) {
    const expanded = secondBtn.getAttribute('aria-expanded') === 'true';
    if (!expanded) secondBtn.click();
  }
});

document.addEventListener('mouseover', function (e) {
  if (window.innerWidth < 1024) return;

  const insideHeaderNav = e.target.closest('header .header-inline-nav');
  if (insideHeaderNav) return;

  document.querySelectorAll('header .first-sub-menu-toggle[aria-expanded="true"]').forEach((btn) => {
    btn.click();
  });
});